import api from "./api";
import auth from "./auth";

const ESTORE_SERVICE_URL = "estore-service";

export default {
  getInventoryList({ page, payload }) {
    return new Promise((resolve, reject) => {
      api.post(
        `${ESTORE_SERVICE_URL}/v1/cms/estore/inventory/list/${page}`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  getProductInventoryList({ page, productId, payload }) {
    return new Promise((resolve, reject) => {
      api.post(
        `${ESTORE_SERVICE_URL}/v1/cms/estore/product/${productId}/inventory/list/${page}`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  updateInventory(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${ESTORE_SERVICE_URL}/v1/cms/estore/product/inventory/update`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  updateAddOns(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${ESTORE_SERVICE_URL}/v1/cms/estore/product/add-ons/update`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  }
};
